/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

/** List prescription templates owned by the current professional. */
export const listRxTemplates = async () =>
  (await api.get('/rx-templates')).data;

/** Create a new template from a filled prescription form. */
export const createRxTemplate = async (payload) =>
  (await api.post('/rx-templates', payload)).data;

/** Update an existing template. */
export const updateRxTemplate = async (id, payload) =>
  (await api.put(`/rx-templates/${id}`, payload)).data;

/** Delete a template. */
export const deleteRxTemplate = async (id) =>
  (await api.delete(`/rx-templates/${id}`)).data;

/** Increment the usage counter (moves the template to the top of the list). */
export const bumpRxTemplateUsage = async (id) =>
  (await api.post(`/rx-templates/${id}/use`)).data;

/** Doctor-side aggregated stats — top prescribed drugs. */
export const getTopPrescribed = async ({ days = 30, limit = 10 } = {}) => {
  const params = new URLSearchParams();
  params.set('days', String(days));
  params.set('limit', String(limit));
  return (await api.get(`/rx-analytics/top?${params.toString()}`)).data;
};

/** Upload the clinic logo as a base64 data URI. */
export const uploadBrandLogo = async (dataUri) =>
  (await api.post('/admin/brand-settings/logo', { data_uri: dataUri })).data;
